var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('figure',{staticClass:"image is-48x48 center"},[_c('img',{attrs:{"src":"/spin.gif"}})])])
}]

export { render, staticRenderFns }